import React, { useContext, useRef, forwardRef, useState } from 'react'
import { Modal, RadioGroup, Button, Input, Toast, FormItem } from '@ow/comps'
import { Controller } from 'react-hook-form'
import useEditForm from './hooks/use-edit-user'
import OrgContext from '../../hooks/org/context'

const renderType = function () {
  // const { username = '', mobile } = obj
  // if (mobile) {
  //   return '注册账号'
  // }
  // if ((username || '').indexOf('@') > -1) {
  //   return '子账号'
  // }
  // return '检查吧账号'
  return '子账号'
}

const EditUserModal = function (
  { user = {}, closeModal, updateCurrentUser, useUserApi = {} },
  ref
) {
  const [isUpdMobile, setUpdMobile] = useState(false)
  const [isUpdName, setUpdName] = useState(false)
  const [isUpdRole, setUpdRole] = useState(false)
  const formRef = useRef(null)
  const { userOperate } = useUserApi
  const { updateUser } = userOperate
  const { roles } = useContext(OrgContext) || {}
  const userRole = (roles || []).find((v) => v.value === user.roleSlug) || {}
  const {
    reset,
    control,
    formState: { errors },
  } = useEditForm(
    {
      currentUser: {
        username: user.username,
        name: user.name,
        mobile: user.mobile,
        roleId: userRole.id,
      },
    },
    formRef
  )

  const onSubmit = () => {
    const data = formRef.current.getValues()

    formRef.current.trigger().then((tr) => {
      if (tr) {
        updateUser(
          {
            name: isUpdName ? data.name : null,
            // username: data.username,
            id: user.id,
            roleId: isUpdRole ? data.roleId : null,
            mobile: isUpdMobile ? data.mobile : null,
          },
          () => {
            if (updateCurrentUser) {
              updateCurrentUser()
            }
            if (closeModal) {
              closeModal()
            }
            reset()
          }
        ).catch((error) => {
          Toast.error({
            title: '失败',
            description: error.message,
          })
        })
      }
    })
  }

  const close = () => {
    if (closeModal) {
      closeModal()
    }
    reset()
  }

  return (
    <Modal
      ref={ref}
      title="编辑用户"
      size="md"
      showCloseButton
      closeOnDocumentClick={false}
      onClose={close}
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={() => {
        return (
          <div className="-full flex flex-row justify-end">
            <Button stroke onClick={close} className="mr-2">
              取消
            </Button>
            <Button type="primary" onClick={onSubmit}>
              确定
            </Button>
          </div>
        )
      }}
    >
      <div className="flex flex-col -mt-2 mb-20">
        <div className="w-full flex flex-row items-center">
          <FormItem label="用户类型" className="w-full mt-2">
            <Input disabled className="w-full mt-2" value={renderType(user)} />
          </FormItem>
        </div>
        {/* {user.username ? ( */}
        <div className="w-full flex flex-row items-center">
          <FormItem
            required
            label="用户名"
            error={
              errors.username && errors.username.type === 'required' && '必填项'
            }
            className="w-full mt-2"
          >
            <Controller
              render={({ field }) => {
                return (
                  <Input
                    {...field}
                    placeholder="请输入"
                    className="w-full mt-2"
                    onChange={(e) => {
                      field.onChange(e)
                    }}
                    disabled
                  />
                )
              }}
              name="username"
              rules={{ required: true }}
              control={control}
              defaultValue={user.username}
            />
          </FormItem>
        </div>
        {/* ) : ( */}
        <div className="w-full flex flex-row items-center">
          <FormItem
            required
            label="手机号"
            error={
              errors.mobile && errors.mobile.type === 'required' && '必填项'
            }
            className="w-full mt-2"
          >
            <Controller
              render={({ field }) => {
                return (
                  <Input
                    {...field}
                    placeholder="请输入"
                    className="w-full mt-2"
                    onChange={(e) => {
                      field.onChange(e)
                      setUpdMobile(true)
                    }}
                  />
                )
              }}
              name="mobile"
              rules={{ required: true }}
              control={control}
              defaultValue={user.mobile}
            />
          </FormItem>
        </div>
        {/* )} */}
        <div className="w-full flex flex-row items-center">
          <FormItem
            required
            label="用户姓名"
            error={errors.name && errors.name.type === 'required' && '必填项'}
            className="w-full mt-2"
          >
            <Controller
              render={({ field }) => {
                return (
                  <Input
                    {...field}
                    placeholder="请输入"
                    className="w-full mt-2"
                    onChange={(e) => {
                      field.onChange(e)
                      setUpdName(true)
                    }}
                  />
                )
              }}
              name="name"
              rules={{ required: true }}
              control={control}
              defaultValue={user.name}
            />
          </FormItem>
        </div>
        <div className="w-full flex flex-row items-center">
          <FormItem
            required
            label="用户角色"
            error={
              errors.roleId && errors.roleId.type === 'required' && '必填项'
            }
            className="w-full mt-2"
          >
            <Controller
              render={({ field }) => {
                const arr =
                  roles.map((v) => {
                    return { ...v, value: v.id }
                  }) || []
                return (
                  <RadioGroup
                    {...field}
                    options={arr}
                    onChange={(e) => {
                      setUpdRole(true)
                      field.onChange(e)
                    }}
                    checkedValues={[field.value]}
                  />
                )
              }}
              name="roleId"
              rules={{ required: true }}
              control={control}
              defaultValue={userRole.id}
            />
          </FormItem>
        </div>
      </div>
    </Modal>
  )
}

export default forwardRef(EditUserModal)
